import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/Login'
import Loginqek from '@/pages/Loginqek'
import home from '@/pages/home'
import largescreen from '@/pages/largeScreen'
import index from '@/pages/index'
import Loginxl from "@/pages/loginxl";
import Loginlnj from "@/pages/loginlnj";
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'default',
      component: Login
    },
    {
      path: '/largescreen',
      name: 'largescreen',
      component: largescreen
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/loginqek',
      name: 'loginqek',
      component: Loginqek,
    },
    {
      path:'/loginxl',
      name:'loginxl',
      component:Loginxl
    },
    {
      path:'/loginlnj',
      name:'loginlnj',
      component:Loginlnj
    },
    {
      path: '/home',
      name: 'home',
      component: home,
      children:[
        {
          path: '',
          component: () => import('@/pages/homepage/homepage'),
        },
        {
          path: 'homepage',
          component: () => import('@/pages/homepage/homepage'),
        },
        {
          path: 'personalcenter',
          component: () => import('@/pages/personalcenter/personalcenter'),
        },
        {
          path: 'equipmentmanagement',
          component: () => import('@/pages/equipmentmanagement/equipmentmanagement'),
        },
        {
          path: 'rawmaterial',
          component: () => import('@/pages/rawmaterial/rawmaterial'),
        },
        {
          path: 'equipmentinspection',
          component: () => import('@/pages/equipmentmanagement/equipmentinspection'),
        },
        {
          path: 'malfunctionmanage',
          component: () => import('@/pages/malfunctionmanage/malfunctionmanage'),
        },
        {
          path: 'xianmobeveragemanage',
          component: () => import('@/pages/beveragemanage/xianmobeveragemanage'),
        },
        {
          path: 'surongbeveragemanage',
          component: () => import('@/pages/beveragemanage/surongbeveragemanage'),
        },
        {
          path: 'e3sbeveragemanage',
          component: () => import('@/pages/beveragemanage/e3sbeveragemanage'),
        },
        {
          path: 'beveragearrange',
          component: () => import('@/pages/beveragearrange/beveragearrange'),
        },
        {
          path: 'e3sbeveragearrange',
          component: () => import('@/pages/beveragearrange/e3sbeveragearrange'),
        },
        {
          path: 'speeddelay',
          component: () => import('@/pages/speeddelay/speeddelay'),
        },
        {
          path: 'operatelog',
          component: () => import('@/pages/operatelog/operatelog'),
        },
        {
          path: 'promotions',
          component: () => import('@/pages/promotions/promotions'),
        },
        {
          path: 'remotecontrol',
          component: () => import('@/pages/remotecontrol/remotecontrol'),
        },
        {
          path: 'saledata',
          component: () => import('@/pages/saledata/saledata'),
        },
        {
          path: 'equiptypeconfig',
          component: () => import('@/pages/standardconfig/equiptypeconfig'),
        },
        {
          path: 'yh-rawMaterial',
          component: () => import('@/pages/yonghe/rawMaterial'),
        },
        {
          path: 'yh-cupSize',
          component: () => import('@/pages/yonghe/cupSize'),
        },
        {
          path: 'yh-group',
          component: () => import('@/pages/yonghe/group'),
        },
        {
          path: 'yh-formula',
          component: () => import('@/pages/yonghe/formula'),
        },
        {
          path: 'yh-template',
          component: () => import('@/pages/yonghe/template'),
        },
        {
          path: 'yh-assign',
          component: () => import('@/pages/yonghe/assignFormula'),
        },
        {
          path: 'yh-resetCache',
          component: () => import('@/pages/yonghe/resetCache'),
        },
        {
          path: 'yh-rawMaterial-ai',
          component: () => import('@/pages/yonghe/rawMaterial-ai'),
        },
        {
          path: 'yh-formula-ai',
          component: () => import('@/pages/yonghe/formula-ai'),
        },
        {
          path: 'yh-assign-ai',
          component: () => import('@/pages/yonghe/assignFormula-ai'),
        },
        {
          path: 'standardconfig',
          component: () => import('@/pages/standardconfig/standardconfig'),
        },
        {
          path: 'userlevelconfig',
          component: () => import('@/pages/standardconfig/userlevelconfig'),
        },
        {
          path: 'trafficwarning',
          component: () => import('@/pages/trafficwarning/trafficwarning'),
        },
        {
          path: 'myduty',
          component: () => import('@/pages/myduty/myduty'),
        },
        {
          path: 'usermanagement',
          component: () => import('@/pages/usermanagement/usermanagement'),
        },
        {
          path: 'equipmentuser_detail',
          component: () => import('@/pages/usermanagement/equipmentuser_detail'),
        },
        {
          path: 'logginaccount',
          component: () => import('@/pages/logginaccount/logginaccount'),
        },
        {
          path: 'payconfig',
          component: () => import('@/pages/payconfig/payconfig'),
        },
        {
          path: 'HuiFuAppConfig',
          component: () => import('@/pages/payconfig/HuiFuAppConfig'),
        },
        {
          path: 'HuiFuPaymentConfig',
          component: () => import('@/pages/payconfig/HuiFuPaymentConfig'),
        },
        {
          path: 'HuiFuMemberConfig',
          component: () => import('@/pages/payconfig/HuiFuMemberConfig'),
        },
        {
          path:'miniuser',
          component: () => import('@/pages/miniprogram/miniuser'),
        },
        {
          path:'rechargeStrategy',
          component:() => import('@/pages/miniprogram/rechargeStrategy')
        },
        {
          path:'formeryearssaledata',
          component:() => import('@/pages/saledata/formeryearssaledata')
        },
        {
          path:'newEmployeeBenefits',
          component:() => import('@/pages/miniprogram/NewEmployeeBenefits')
        },
        {
          path:'signInBenefits',
          component:()=>import('@/pages/miniprogram/SignInBenefits')
        },
        {
          path:'washRecords',
          component:()=>import('@/pages/equipmentmanagement/washRecords')
        },
        {
          path:'calibrationRecords',
          component:()=>import('@/pages/equipmentmanagement/calibrationRecords')
        },
        {
          path:'formulaclass',
          component:()=>import('@/pages/teacupmanage/formulaclass')
        },
        {
          path:'formulamanage',
          component:()=>import('@/pages/teacupmanage/formulamanage')
        },
        {
          path:'cupteamachinemanagement',
          component:()=>import('@/pages/cupteamachinemanage/cupteamachinemanagement')
        },
        {
          path:'milkclass',
          component:()=>import('@/pages/milkteamanagement/milkclass')
        },
        {
          path:'milkseriomanage',
          component:()=>import('@/pages/milkteamanagement/milkseriomanage')
        },
        {
          path:'milkteamachinemanagement',
          component:()=>import('@/pages/milkteamanagement/milkteamachinemanagement')
        },
        {
          path:'Person',
          component:()=>import('@/pages/personalcenter/Person')
        },
        {
          path:'UpdateRecord',
          component:()=>import('@/pages/operatelog/UpdateRecord')
        },
        {
          path: 'NestRawMaterial',
          component: () => import('@/pages/rawmaterial/NestRawMaterial'),
        },
        {
          path: 'SHC430Manage',
          component: () => import('@/pages/beveragemanage/SHC430Manage'),
        },
        {
          path: 'SHC430Arrange',
          component: () => import('@/pages/beveragearrange/SHC430Arrange'),
        },
        {
          path: 'LHC330Manage',
          component: () => import('@/pages/beveragemanage/LHC330Manage'),
        },
        {
          path: 'LHC330Arrange',
          component: () => import('@/pages/beveragearrange/LHC330Arrange'),
        },
        {
          path: 'WechatGroup',
          component: () => import('@/pages/logginaccount/WechatGroup'),
        },
        {
          path:"rawAttention",
          component: () => import('@/pages/equipmentmanagement/RawAttention'),
        },
        {
          path:"rawMaintain-EQ",
          component:()=>import('@/pages/equipmentmanagement/RawMaintain-EQ')
        },
        {
          path:"video-maintain",
          component:()=>import('@/pages/equipmentmanagement/VideoMaintain')
        }
      ]
    }
  ]
})

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}





// WEBPACK FOOTER //
// ./src/router/index.js